module.exports = __webpack_public_path__ + "svg/ArticlePreview.48575a8.svg";